import {
    ELEMENT_TYPE,
    IAppLenovoCourse,
    IAppPopular as IAppOriginPopular,
    OBJ_TYPE as SEARCH_OBJ_TYPE,
} from '@umu/umu-types';

export enum SearchRange {
    currentPage = 'currentPage',
    wholeStation = 'wholeStation',
}

export enum SearchInputForContentInputType {
    umuCommon = 'umuCommon',
    umuMicroPage = 'umuMicroPage',
    useCommon = 'useCommon',
    useMicroPage = 'useMicroPage',
}

export interface IAppPopular extends IAppOriginPopular {
    session_type?: ELEMENT_TYPE;
}

export interface IAppLenovoElement extends IAppLenovoCourse {
    session_type?: ELEMENT_TYPE;
}

export type ISearchObjLabelMap = {
    [propName in SEARCH_OBJ_TYPE]: {
        label: string;
        class: string;
    };
};

export enum INPUT_CLICK_STATUS {
    BUBBLE = 'bubble',
    POPULAR = 'popular',
    COURSE = 'course',
    MOUSEDOWN = 'mousedown',
    LENOVO = 'lenovo',
}

export enum ContentMode {
    Search = 'search',
    Normal = 'normal',
}

export type Iparams = {
    [x: string]: string | number;
};

export type ICallBack = (data: IAppSearchData, key: string) => void;
